import Vue from 'vue'
import ICS from 'vue-ics'

Vue.use(ICS)
